export default {
  state: {
    cart: {
      isOpen: true,
    },
    menu: {
      isOpen: true,
      isMini: true
    },
    alert: {
      isOpen: false
    }
  },
  getters: {
    isCartOpen(state) {
      return state.cart.isOpen
    },
    isMenuOpen(state) {
      return state.menu.isOpen
    }
  },
  actions: {
    setCartIsOpen({ commit }, value){
      commit('SET_CART_IS_OPEN', value)
    }
  },
  mutations: {
    SET_CART_IS_OPEN(state, value) {
      state.cart.isOpen = !!value
    },
    toggleAlertDrawer(state) {
      const inverse = !state.alert.isOpen
      state.alert = {
        ...state.alert,
        isOpen: inverse
      }
    },
    setAlertIsOpen(state, val) {
      state.alert.isOpen = !!val
    },
    toggleMenuDrawer(state) {
      const inverse = !state.menu.isOpen
      state.menu = {
        ...state.menu,
        isOpen: inverse
      }
    },
    setMenuIsOpen(state, val) {
      state.menu.isOpen = !!val
    }
  },
}
